// @flow
import React from 'react';
import * as PropTypes from "prop-types";

const LoadingOverlay = ({ show=false, message=null }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="loading-overlay">
            <div className="loading-overlay-content">
                <i className="fa fa-spinner fa-pulse fa-3x fa-fw" aria-hidden="true" />
                {message && <div className="loading-overlay-message">{message}</div>}
            </div>
        </div>
    );
};

LoadingOverlay.propTypes = {
    show: PropTypes.bool.isRequired,
    message: PropTypes.string,
};

export default LoadingOverlay;
